import { render } from "./Components.vue?vue&type=template&id=5c27ecb9&scoped=true"
import script from "./Components.vue?vue&type=script&lang=js"
export * from "./Components.vue?vue&type=script&lang=js"

import "./Components.vue?vue&type=style&index=0&id=5c27ecb9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c27ecb9"]])

export default __exports__